export const routes = [
  {
    path: "/municipioAds",
    component: () => import(/* webpackChunkName: "ur" */ "./components/List"),
    name: "municipioAds.list",
    meta: {
      requiresAuth: true,
    },
  },
];
